/**
 * Handle search and filter desktop
 */

const sf_results_desktop = document.querySelector(
  '.l-investments__results--desktop > .search-filter-results'
);

function panels_on_load() {
  const first_card = sf_results_desktop.querySelector('.m-card');
  const first_btn = first_card.querySelector('a');

  first_card.classList.add('active');
  first_btn.setAttribute('aria-selected', 'true');

  const panels = document.querySelectorAll('.m-panel');

  panels.forEach((panel) => {
    panel.hidden = true;
  });

  const matchingPanel = document.querySelector(
    `.m-panel[aria-labelledby="${first_btn.id}"]`
  );

  if (matchingPanel) {
    matchingPanel.hidden = false;
  }
}

function panels_on_click(el) {
  const clicked_btn = el.currentTarget;
  const clicked_card = clicked_btn.closest('.m-card--investment-tab');

  const cards = document.querySelectorAll('.m-card--investment-tab');

  cards.forEach((card) => {
    card.classList.remove('active');

    if (card === clicked_card) {
      card.classList.add('active');
    }
  });

  const panels = document.querySelectorAll('.m-panel');

  panels.forEach((panel) => {
    panel.hidden = true;
  });

  const matching_panel = document.querySelector(
    `.m-panel[aria-labelledby="${clicked_btn.id}"]`
  );

  if (matching_panel) {
    matching_panel.hidden = false;
  }
}

if (sf_results_desktop && sf_results_desktop.style.display !== 'none') {
  // Select first items on load
  window.addEventListener('load', panels_on_load);

  // Handle btn clicks
  const btns = sf_results_desktop.querySelectorAll('a');

  btns.forEach((btn) => {
    btn.addEventListener('click', panels_on_click);
  });

  const observer_desktop = new MutationObserver(() => {
    // Select first items on filter
    panels_on_load();

    // Handle clicks after filter
    const updated_btns = sf_results_desktop.querySelectorAll('a');

    updated_btns.forEach((btn) => {
      btn.addEventListener('click', panels_on_click);
    });
  });

  observer_desktop.observe(sf_results_desktop, {
    childList: true,
    subtree: true,
  });
}
